import { render, staticRenderFns } from "./LeadDistribution.vue?vue&type=template&id=22c3ec57&"
import script from "./LeadDistribution.vue?vue&type=script&lang=js&"
export * from "./LeadDistribution.vue?vue&type=script&lang=js&"
import style0 from "./LeadDistribution.vue?vue&type=style&index=0&id=22c3ec57&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports